export const TIME_PERIOD_PRESETS = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  THIS_WEEK: 'this_week',
  LAST_WEEK: 'last_week',
  THIS_MONTH: 'this_month',
  LAST_MONTH: 'last_month',
  LAST_7_DAYS: 'last_7_days',
  LAST_30_DAYS: 'last_30_days',
  CUSTOM: 'custom',
};

export const TIME_PERIOD_PRESET_ORDER = [
  TIME_PERIOD_PRESETS.TODAY,
  TIME_PERIOD_PRESETS.YESTERDAY,
  TIME_PERIOD_PRESETS.THIS_WEEK,
  TIME_PERIOD_PRESETS.LAST_WEEK,
  TIME_PERIOD_PRESETS.THIS_MONTH,
  TIME_PERIOD_PRESETS.LAST_MONTH,
  TIME_PERIOD_PRESETS.LAST_7_DAYS,
  TIME_PERIOD_PRESETS.LAST_30_DAYS,
];

export const DEFAULT_TIME_PERIOD_PRESET = TIME_PERIOD_PRESETS.THIS_MONTH;

export const MAX_TIME_PERIOD_DAYS = 365;

export const DEFAULT_REPORT_TYPE = 'summary_invoice';

export const ALL_FILTER_VALUE = 'all';

export const REPORT_TYPE_OPTIONS = [
  { value: 'summary_invoice', labelKey: 'report_type_summary_invoice' },
  { value: 'detailed_line_item', labelKey: 'report_type_detailed_line_item' },
];

export const DOC_TYPE_FILTER_OPTIONS = [
  { value: ALL_FILTER_VALUE, labelKey: 'doc_type_all' },
  { value: 'sales_invoice', labelKey: 'doc_type_sales_invoice' },
  { value: 'sales_credit_note', labelKey: 'doc_type_sales_credit_note' },
  { value: 'purchase_invoice', labelKey: 'doc_type_purchase_invoice' },
  { value: 'purchase_credit_note', labelKey: 'doc_type_purchase_credit_note' },
];

export const DOC_TYPE_CONCRETE_VALUES = DOC_TYPE_FILTER_OPTIONS.filter(
  (option) => option.value !== ALL_FILTER_VALUE,
).map((option) => option.value);

export const EDOC_FILTER_OPTIONS = [
  { value: ALL_FILTER_VALUE, labelKey: 'edoc_all' },
  { value: 'E_INVOICE', labelKey: 'edoc_e_invoice' },
  { value: 'NON_E_INVOICE', labelKey: 'edoc_non_e_invoice' },
];

export const EDOC_CONCRETE_VALUES = EDOC_FILTER_OPTIONS.filter((option) => option.value !== ALL_FILTER_VALUE).map(
  (option) => option.value,
);

export const STATUS_CONCRETE_VALUES = ['PENDING', 'APPROVED', 'REJECTED', 'VALIDATION_FAILED'];

export const DOCUMENT_REPORT_FILTER_KEYS = {
  TIN: 'tin',
  DOC_TYPE: 'docTypes',
  EDOC: 'eDoc',
  STATUS: 'status',
  REPORT_TYPE: 'reportType',
  TIME_PERIOD: 'timePeriod',
};

export const SELECT_ALL_SEMANTICS_FILTER_KEYS = [
  DOCUMENT_REPORT_FILTER_KEYS.DOC_TYPE,
  DOCUMENT_REPORT_FILTER_KEYS.EDOC,
  DOCUMENT_REPORT_FILTER_KEYS.STATUS,
];

export const DOCUMENT_REPORT_ERROR_CODES = {
  REQUIRED: 'required',
  RANGE_TOO_LONG: 'range_too_long',
};

/**
 * Selecting All checks All + every concrete option. Payload should strip All and send concretes.
 * Unchecking All clears every option.
 */
export const applySelectAllSemantics = (prev = [], next = [], concreteValues = []) => {
  const prevHasAll = prev.includes(ALL_FILTER_VALUE);
  const nextHasAll = next.includes(ALL_FILTER_VALUE);
  const selectedConcrete = next.filter((value) => value !== ALL_FILTER_VALUE);

  if (nextHasAll && !prevHasAll) {
    return [ALL_FILTER_VALUE, ...concreteValues];
  }

  if (prevHasAll && !nextHasAll) {
    return [];
  }

  if (next.length === 0) {
    return [];
  }

  if (concreteValues.length > 0 && concreteValues.every((value) => selectedConcrete.includes(value))) {
    return [ALL_FILTER_VALUE, ...concreteValues];
  }

  return selectedConcrete;
};

export const stripAllFilterValue = (values = []) => values.filter((value) => value !== ALL_FILTER_VALUE);

export const getDefaultDocumentReportFilters = () => ({
  tin: [],
  docTypes: [],
  eDoc: [],
  status: [],
  reportType: DEFAULT_REPORT_TYPE,
  timePeriod: {
    preset: DEFAULT_TIME_PERIOD_PRESET,
    startDate: null,
    endDate: null,
  },
});
